import { EyeIcon, EyeOffIcon } from "lucide-react";
import { useState } from "react";

import { useViewWallet } from "@/api/wallet-query";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { formatCurrency } from "@/lib/utils";

import { Deposit } from "./deposit";
import { Withdraw } from "./withdraw";

type SelectedBalance = "total" | "available" | "locked";
export function WalletCard() {
	const [showBalance, setShowBalance] = useState(false);

	const [selected, setSelected] = useState<SelectedBalance>("total");
	const { data } = useViewWallet();
	const balance = selected === "total"
		? (Number(data?.data.tiedBalance) + Number(data?.data.withdrawableBalance))
		: selected === "locked"
			? Number(data?.data.tiedBalance)
			: selected === "available"
				? Number(data?.data.withdrawableBalance)
				: Math.abs(Number(data?.data.withdrawableBalance) - (Number(data?.data.tiedBalance)));

	return (
		<Card className="bg-zinc-800 text-white border-none">
			<CardHeader className="flex-row flex-wrap items-center justify-between space-y-0">
				<div>
					<h2 className="text-xl font-semibold">Wallet</h2>
					<p className="text-sm text-zinc-400">Available for use</p>
				</div>

				<Select defaultValue="total" onValueChange={value => setSelected(value as SelectedBalance)}>
					<SelectTrigger className="w-[160px] text-white border-none outline-none bg-white/5 rounded-lg">
						<SelectValue placeholder="Select an option" />
					</SelectTrigger>
					<SelectContent className="">
						<SelectItem value="total">Total balance</SelectItem>
						<SelectItem value="locked">Locked balance</SelectItem>
						<SelectItem value="available">Available</SelectItem>
					</SelectContent>
				</Select>
			</CardHeader>
			<CardContent>
				<div className="p-6 bg-white/95 *:text-black rounded-lg space-y-6">
					<div>
						<div className="text-sm capitalize flex items-center">
							{selected}
							{" "}
							Balance
							<Button variant="ghost" size="sm" className="size-10" onClick={() => setShowBalance(!showBalance)}>
								{showBalance ? <EyeIcon /> : <EyeOffIcon />}
							</Button>
						</div>
						<div className="text-3xl font-bold">
							{
								!showBalance
									? "********"
									: !data
											? formatCurrency(0, "NGN")
											: formatCurrency(balance, "NGN")
							}
						</div>
					</div>
					<div className="grid grid-cols-2 gap-4">
						<Withdraw />
						<Deposit />
					</div>
				</div>
			</CardContent>
		</Card>
	);
}
